import { Basket, Device } from "@/services/model";
import { mobileAbos, ServiceIDs } from "@/utils/constants";
import {
  Duration,
  TransformedProduct,
  TransformedProductsById,
} from "@/utils/tariffUtils";

export const isSmartphoneInBasket = (basket?: Basket): boolean =>
  isDeviceSmartphone(basket?.entries[0]?.device);

export const isDeviceSmartphone = (device?: Device): boolean =>
  !!device && device.id === 1;

export const getMobileAbos = (
  processedProductsById: TransformedProductsById | undefined,
) =>
  processedProductsById
    ? Object.values(processedProductsById || {}).filter((product) =>
        mobileAbos.includes(`${product.id}`),
      )
    : [];

export const getSortedMobileAbosMonthly = (
  mobileAbos: TransformedProduct[],
) => {
  // Define the desired order by productId
  const desiredOrder = [
    ServiceIDs.FlatMobileSwissMonth,
    ServiceIDs.FlatMobileMonth,
    ServiceIDs.FlatMobilePlusMonth,
  ];

  return mobileAbos
    .filter((abo) => abo.duration === Duration.month)
    .sort((a, b) => desiredOrder.indexOf(a.id!) - desiredOrder.indexOf(b.id!));
};

export const getSortedMobileAbosYearly = (mobileAbos: TransformedProduct[]) => {
  // Define the desired order by productId
  const desiredOrder = [
    ServiceIDs.FlatMobileSwissYear,
    ServiceIDs.FlatMobileYear,
    ServiceIDs.FlatMobilePlusYear,
  ];

  return mobileAbos
    .filter((abo) => abo.duration === Duration.year)
    .sort((a, b) => desiredOrder.indexOf(a.id!) - desiredOrder.indexOf(b.id!));
};
